if (!customElements.get('t4-ship-countdown')) {
  // Honest shipping cutoff: counts down to the next business-day cutoff in the store's
  // time zone (same 2 PM PT, Mon–Fri rule as the product page).
  const parts = (date, timeZone) => {
    const values = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone,
      weekday: 'short',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    })
      .formatToParts(date)
      .forEach(({ type, value }) => (values[type] = value));
    return values;
  };

  const zonedToUtc = (year, month, day, hour, minute, timeZone) => {
    const guess = new Date(Date.UTC(year, month - 1, day, hour, minute));
    const p = parts(guess, timeZone);
    const asUtc = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
    return new Date(guess.getTime() - (asUtc - guess.getTime()));
  };

  customElements.define(
    't4-ship-countdown',
    class T4ShipCountdown extends HTMLElement {
      connectedCallback() {
        this.timeZone = this.dataset.timezone || 'America/Los_Angeles';
        this.cutoffHour = Number(this.dataset.cutoffHour || 14);
        this.cutoffMinute = Number(this.dataset.cutoffMinute || 0);
        this.output = this.querySelector('[data-countdown-text]');
        this.render = this.render.bind(this);
        this.render();
        this.timer = window.setInterval(this.render, 30000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      nextCutoff(now) {
        const weekend = (p) => p.weekday === 'Sat' || p.weekday === 'Sun';
        for (let offset = 0; offset < 8; offset++) {
          const day = new Date(now.getTime() + offset * 86400000);
          const p = parts(day, this.timeZone);
          if (weekend(p)) continue;
          const cutoff = zonedToUtc(+p.year, +p.month, +p.day, this.cutoffHour, this.cutoffMinute, this.timeZone);
          if (cutoff > now) return { cutoff, today: offset === 0, weekday: p.weekday };
        }
        return null;
      }

      render() {
        if (!this.output) return;
        const now = new Date();
        const next = this.nextCutoff(now);
        if (!next) return;

        if (next.today) {
          const minutes = Math.max(1, Math.round((next.cutoff - now) / 60000));
          const hours = Math.floor(minutes / 60);
          const time = hours > 0 ? `${hours}h ${minutes % 60}m` : `${minutes}m`;
          this.output.innerHTML = this.dataset.templateToday.replace('[time]', `<strong>${time}</strong>`);
        } else {
          const day = new Intl.DateTimeFormat('en-US', { weekday: 'long', timeZone: this.timeZone }).format(next.cutoff);
          this.output.innerHTML = this.dataset.templateLater.replace('[day]', `<strong>${day}</strong>`);
        }
        this.hidden = false;
      }
    }
  );
}
